export default __webpack_public_path__ + "static/media/contacto320px.77d41f9c.jpg";